/*
JOSEPH P. PASAOA
Redux Constants | Portfolio Site
*/


export const AN_ACTION = "AN_ACTION";
